import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const leadingColumnStyle = css`
  display: flex;
  grid-column-end: lead;
  grid-column-start: lead;
  grid-row-end: lead;
  grid-row-start: lead;
  padding-right: ${theme.spacing(2)};
  align-items: center;
`;

export const LeadingColumn = ({ children, ...rest }: { children: React.ReactNode }) => {
  return (
    <div className={leadingColumnStyle} {...rest}>
      {children}
    </div>
  );
};
